export const GET_IFA_EMPLOYERS = "GET_IFA_EMPLOYERS";
export const GET_IFA_EMPLOYERS_SUCCESS = "GET_IFA_EMPLOYERS_SUCCESS";
export const GET_IFA_EMPLOYERS_ERROR = "GET_IFA_EMPLOYERS_ERROR";
export const ACCESS_IFA_EMPLOYERS = "ACCESS_IFA_EMPLOYERS";
export const ACCESS_IFA_EMPLOYERS_SUCCESS = "ACCESS_IFA_EMPLOYERS_SUCCESS";
export const ACCESS_IFA_EMPLOYERS_ERROR = "ACCESS_IFA_EMPLOYERS_ERROR";
export const GET_IFA_EMPLOYEES = "GET_IFA_EMPLOYEES";
export const GET_IFA_EMPLOYEES_SUCCESS = "GET_IFA_EMPLOYEES_SUCCESS";
